import { type OnboardingStep, useInvalidating } from "@/lib/api";

export function useCompleteStep() {
  return useInvalidating(
    (api, step: OnboardingStep) =>
      api.POST("/onboarding/complete-step", { body: { step } }),
    [["me"], ["knowledge"], ["websites"]],
  );
}
